<template>
  <b-overlay :show="loading">
    <div>
      <b-card
        no-body
        class="mb-0"
      >
        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :disabled="loading"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entries</label>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <div class="d-flex align-items-center justify-content-end">
              </div>
            </b-col>
          </b-row>

        </div>

        <b-table
          ref="refDataTable"
          class="position-relative"
          :items="apiKeyUsageRecords"
          :fields="tableColumns"
          responsive
          show-empty
          primary-key="id"
          empty-text="No matching records found"
        >
          <template #cell(device_type)="data">
            <span>{{ getValueFromSource(data, 'item.device.device_type') || 'N/A' }}</span>
          </template>

          <template #cell(device_name)="data">
            <span>{{ getValueFromSource(data, 'item.device.name') || 'N/A' }}</span>
          </template>

          <template #cell(date)="data">
            <span>
              {{ formatDate(getValueFromSource(data.item, 'created')) }}
            </span>
          </template>

          <template #cell(time)="data">
            <span>
              {{ formatDate(getValueFromSource(data.item, 'created'), 'HH:mm a') }}
            </span>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRecords"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BMedia, BAvatar, BButton, VBTooltip,
  BOverlay, BCard, BRow, BCol, BAlert, BLink, BTable,
  BBadge, BDropdown, BDropdownItem, BPagination
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { get } from "lodash"

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const watchHandler = {
  handler(){
    this.fetchAllData()
  }, 
  immediate: false
}

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BOverlay,
    BCard,
    BTable,
    BRow,
    BCol,
    BAlert,
    BBadge,
    BLink,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BPagination,
    BButton,

    vSelect,
  },
  props: {
    tableColumns: {
      type: Array,
      default: () => {
          return [
          { key: 'device_type', sortable: false },
          { key: 'device_name', sortable: false },
          { key: 'ip_address', sortable: false },
          { key: 'date', sortable: false, label: 'Date' },
          { key: 'time', sortable: false, label: 'Time' },
        ]
      }
    }
  },
  data(){
    return {
      loading: false,
      totalRecords: 0,
      currentPage: 1,
      perPage: 50,
      perPageOptions: [50, 100, 150, 250, 500],
      statusFilter: null,
      apiKeyUsageRecords: [],
    }
  },
  computed: {
    dataMeta(){
      const localItemsCount = this.apiKeyUsageRecords.length || 0;
      return {
        from: this.perPage * (this.currentPage - 1) + (localItemsCount ? 1 : 0),
        to: this.perPage * (this.currentPage - 1) + localItemsCount,
        of: this.totalRecords,
      }
    },
  },
  watch: {
    currentPage: watchHandler,
  },
  created(){
    this.fetchAllData();
  },
  methods: {
    async fetchAllData() {
      try {
        this.loading = true; 
        const { api_key_id } = this.$route.params

        const query = {
          limit: this.perPage,
          page: this.currentPage,
        }

        const request = await this.useJwt().mainService.apiKeys.fetchAPIKeyUsage(api_key_id, query);
        const { data, pagination } = request.data;

        this.totalRecords = pagination.totalRecords
        this.perPage = pagination.limit;

        this.apiKeyUsageRecords = data;
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
    async onDeactivateBankAPI(bankAPI){
      try { 
        this.loading = true;

        const result = await this.$swal({
          title: 'Confirm Deactivate?',
          text: "This will deactivate this bank access key.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, deactivate it.',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        });

        if (!result.value){
          return;
        }

        const api_key_id = bankAPI._id;
        await this.useJwt().mainService.revoke(api_key_id);
        await this.fetchAllData();
      } catch (error){
        this.loading = false;

        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  @import '@core/scss/vue/libs/vue-select.scss';
  .width-100 {
    width: 100px;
  }
  .per-page-selector {
    width: 90px;
  }
</style>



